/**
 * Fires a new GTM Metric pushing it to the data layer
 * @param {*} eventType the type of the event
 * @param {*} pagePath the url of the page
 * @param {*} pageTitle the title of the page
 * @param {*} userMetadata the user metadata {user_id, ...}
 * @param {*} dataLayerName the name of the Data Layer defaults to PAGE_METRICS_DATALAYER_NAME
 */
export const fireGTMMetric = (eventType, pagePath, pageTitle, userMetadata) => {
    window.pageMetricsDataLayer?.push({
        event: eventType,
        pagePath,
        pageTitle,
        ...userMetadata,
    });
};
